import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'

export const mapEntityTypeToLibraryElement: Partial<
  Record<EntityTypeEnum, LibraryElementEnum>
> = {
  [EntityTypeEnum.Section]: LibraryElementEnum.LibrarySection,
  [EntityTypeEnum.Row]: LibraryElementEnum.LibraryRow,
  [EntityTypeEnum.Column]: LibraryElementEnum.LibraryColumn3,
  [EntityTypeEnum.ContentBox]: LibraryElementEnum.LibraryContentBox,
  [EntityTypeEnum.Headline]: LibraryElementEnum.LibraryHeadline,
  [EntityTypeEnum.BulletList]: LibraryElementEnum.LibraryBulletList,
  [EntityTypeEnum.BookingCalendar]: LibraryElementEnum.LibraryCalendar,
  [EntityTypeEnum.BookingPaidCalendar]: LibraryElementEnum.LibraryPaidCalendar,
  [EntityTypeEnum.Video]: LibraryElementEnum.LibraryVideo,
  [EntityTypeEnum.Image]: LibraryElementEnum.LibraryImage,
  [EntityTypeEnum.Audio]: LibraryElementEnum.LibraryAudio,
  [EntityTypeEnum.Button]: LibraryElementEnum.LibraryButton,
  [EntityTypeEnum.ContactUsButton]: LibraryElementEnum.LibraryContactUsButton,
  [EntityTypeEnum.WebsiteButton]: LibraryElementEnum.LibraryWebsiteButton,
  [EntityTypeEnum.LoginButton]: LibraryElementEnum.LibraryLoginButton,
  [EntityTypeEnum.RegistrationButton]:
    LibraryElementEnum.LibraryRegistrationButton,
  [EntityTypeEnum.PaymentButton]: LibraryElementEnum.LibraryPaymentButton,
  [EntityTypeEnum.UpsellAgreeButton]:
    LibraryElementEnum.LibraryUpsellAgreeButton,
  [EntityTypeEnum.UpsellDisagreeButton]:
    LibraryElementEnum.LibraryUpsellDisagreeButton,
  [EntityTypeEnum.Field]: LibraryElementEnum.LibraryField,
  [EntityTypeEnum.Form]: LibraryElementEnum.LibraryForm,
  [EntityTypeEnum.Countdown]: LibraryElementEnum.LibraryCountdown,
  [EntityTypeEnum.WebinarRegistrationDate]:
    LibraryElementEnum.LibraryWebinarRegistrationDate,
  [EntityTypeEnum.OrderSummary]: LibraryElementEnum.LibraryOrderSummary,
  [EntityTypeEnum.WebinarSessionDateTime]:
    LibraryElementEnum.LibraryWebinarSessionDateTime,
  [EntityTypeEnum.WebinarSessionLink]:
    LibraryElementEnum.LibraryWebinarSessionLink,
  [EntityTypeEnum.CustomerType]: LibraryElementEnum.LibraryCustomerType,
  [EntityTypeEnum.OfferPrice]: LibraryElementEnum.LibraryOfferPrice,
  [EntityTypeEnum.RawHtml]: LibraryElementEnum.LibraryRawHTML,
  [EntityTypeEnum.Checkbox]: LibraryElementEnum.LibraryCheckbox,
  [EntityTypeEnum.Agreement]: LibraryElementEnum.LibraryAgreement,
  [EntityTypeEnum.CustomLogin]: LibraryElementEnum.LibraryCustomLogin,
  [EntityTypeEnum.Product]: LibraryElementEnum.LibraryProduct,
  [EntityTypeEnum.SalesRedirectionButton]:
    LibraryElementEnum.LibrarySalesRedirectionButton,
  [EntityTypeEnum.Coupon]: LibraryElementEnum.LibraryCoupon,
  [EntityTypeEnum.WebinarCallToAction]:
    LibraryElementEnum.LibraryWebinarCallToAction,
  [EntityTypeEnum.WebinarSessionVideo]:
    LibraryElementEnum.LibraryWebinarSessionVideo,
  [EntityTypeEnum.PaymentMethod]: LibraryElementEnum.LibraryPaymentMethod,
  [EntityTypeEnum.BlogPostBody]: LibraryElementEnum.LibraryBlogPostBody,
  [EntityTypeEnum.BlogPostTitle]: LibraryElementEnum.LibraryBlogPostTitle,
  [EntityTypeEnum.BlogPostDate]: LibraryElementEnum.LibraryBlogPostDate,
  [EntityTypeEnum.BlogPostCategories]:
    LibraryElementEnum.LibraryBlogPostCategories,
  [EntityTypeEnum.BlogPostListing]: LibraryElementEnum.LibraryBlogPostListing,
  [EntityTypeEnum.LatestBlogPosts]: LibraryElementEnum.LibraryBlogLatestPosts,
  [EntityTypeEnum.LatestBlogPostsCarousel]:
    LibraryElementEnum.LibraryLatestBlogPostsCarousel,
  [EntityTypeEnum.HorizontalLine]: LibraryElementEnum.LibraryHorizontalLine,
  [EntityTypeEnum.BlogContentPlaceholder]:
    LibraryElementEnum.LibraryBlogContentPlaceholder,
  [EntityTypeEnum.Menu]: LibraryElementEnum.LibraryMenu,
  [EntityTypeEnum.LanguageSwitcher]: LibraryElementEnum.LibraryLanguageSwitcher,
  [EntityTypeEnum.TwoStepPaymentForm]:
    LibraryElementEnum.LibraryTwoStepPaymentForm,
  [EntityTypeEnum.TwitterTweetButton]:
    LibraryElementEnum.LibraryTwitterTweetButton,
  [EntityTypeEnum.Carousel]: LibraryElementEnum.LibraryCarousel,
  [EntityTypeEnum.Faq]: LibraryElementEnum.LibraryFaq,
  [EntityTypeEnum.Text]: LibraryElementEnum.LibraryText,
  [EntityTypeEnum.BlogPostImage]: LibraryElementEnum.LibraryBlogPostImage,
  [EntityTypeEnum.ContentTable]: LibraryElementEnum.LibraryContentTable,
  [EntityTypeEnum.ContactUs]: LibraryElementEnum.LibraryContactUs,
  [EntityTypeEnum.Breadcrumbs]: LibraryElementEnum.LibraryBreadcrumbs,
  [EntityTypeEnum.Survey]: LibraryElementEnum.LibrarySurvey,
  [EntityTypeEnum.BlogCategoryTitle]:
    LibraryElementEnum.LibraryBlogCategoryTitle,
  [EntityTypeEnum.BlogCategoryDescription]:
    LibraryElementEnum.LibraryBlogCategoryDescription,
  [EntityTypeEnum.OptInRecaptcha]: LibraryElementEnum.LibraryOptInRecaptcha,
  [EntityTypeEnum.ShippingFees]: LibraryElementEnum.LibraryShippingFees,
  [EntityTypeEnum.OrderBump]: LibraryElementEnum.LibraryOrderBump,
  [EntityTypeEnum.PriceElement]: LibraryElementEnum.LibraryPriceElement,
  [EntityTypeEnum.SearchResults]: LibraryElementEnum.LibrarySearchResults,
  [EntityTypeEnum.Search]: LibraryElementEnum.LibrarySearch,
  [EntityTypeEnum.WebsiteLogo]: LibraryElementEnum.LibraryWebsiteLogo,
  [EntityTypeEnum.WebsiteHeader]: LibraryElementEnum.LibraryWebsiteHeader,
  [EntityTypeEnum.WebsiteLanguageSwitcher]:
    LibraryElementEnum.LibraryWebsiteLanguageSwitcher,
}
